import constantsValid from './constantsValid';
import errorMesseage from './errorMesseage';
import notification from './notification';

const manageWordFolder = { constantsValid, errorMesseage, notification };

export default manageWordFolder;
